import React from 'react';

const HeaderIcons = ({
  isFullHeader,
  icons,
  history,
  open,
  isConsultantUser,
  hasResaleProduct,
  hasMobioOneProduct,
}) => {
  const getDesktopIcons = () => {
    if (isFullHeader()) {
      return icons.map((icon, id) => {
        const Icon = icon;
        return (
          <Icon
            key={id}
            open={open}
            history={history}
            isConsultantUser={isConsultantUser}
            hasResaleProduct={hasResaleProduct}
            hasMobioOneProduct={hasMobioOneProduct}
          />
        );
      });
    }

    const Notification = icons[icons.length - 2];
    const Icon = icons[icons.length - 1];
    return (
      <>
        <Notification
          open={open}
          history={history}
          isConsultantUser={isConsultantUser}
          hasResaleProduct={hasResaleProduct}
        />
        <Icon
          open={open}
          history={history}
          isConsultantUser={isConsultantUser}
        />
      </>
    );
  };

  return <>{getDesktopIcons()}</>;
};

export default HeaderIcons;
